import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type ListFilter } from '../types/filters';

export const educationDefinition: FilterDefinition<ListFilter> = {
  id: FilterId.EDUCATION,
  name: 'Education',
  selectionListId: 'highest_degree',
  selections: [],
  type: FilterType.LIST,
  isVisible: true,
};

export const educationHandler: FilterHandler<ListFilter> = {
  isActive(currentFilterState: ListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: ListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: ListFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds(definition: FilterDefinition<ListFilter>) {
    return [definition.selectionListId];
  },
};
